import { render, staticRenderFns } from "./dept.vue?vue&type=template&id=2eb648a9&scoped=true&"
import script from "./dept.vue?vue&type=script&lang=js&"
export * from "./dept.vue?vue&type=script&lang=js&"
import style0 from "./dept.vue?vue&type=style&index=0&id=2eb648a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb648a9",
  null
  
)

export default component.exports